import { RootState } from '@/lib/store';
import { UserRestriction } from '@/models/user-restriction';
import { useSelector } from 'react-redux';
import styles from './styles.module.scss';
import { useLottiePlayer } from '@starsoft/common/hooks';
import { getLottie } from './helper';
import { Nullable } from '@starsoft/common/interfaces';
import { Restriction } from '@/models/restriction';

export default function RestrictionDetailsModalLottie() {
  const userRestrictions: UserRestriction[] = useSelector(
    (state: RootState) => state.userRestrictions.userRestrictions,
  );

  const restriction: Nullable<Restriction> = useSelector(
    (state: RootState) => state.userRestrictions.restriction,
  );

  const { lottieAnimationRef } = useLottiePlayer({
    path: getLottie(userRestrictions, restriction),
    autoplay: true,
    loop: true,
    dependecyArray: [userRestrictions, restriction],
  });

  return (
    <div className={styles.lottie}>
      <div ref={lottieAnimationRef} />
    </div>
  );
}
